module.exports = __webpack_public_path__ + "img/action.1fa75fa0.svg";